import {
  USER_MIGRATION_STATUS,
} from '../constants';

export const checkUserIsEligible = (response) => {
  const { migrationStatus, isUserProfileLocked } = response;
  if (
    migrationStatus === USER_MIGRATION_STATUS
    && isUserProfileLocked === false
  ) {
    return true;
  }
  return false;
};

export const formatData = (key, value) => {
  let returnValue = '';
  if (value === undefined || value === null) {
    returnValue = '';
  } else if (typeof value === 'string') {
    returnValue = value.trim();
  } else {
    returnValue = value;
  }
  return returnValue;
};

export const parseResponse = (response) => {
  const newObj = {
    middleName: response.middleInitial,
    employeeId: response.employeeNumber,
  };
  const updatedObj = { ...response, ...newObj };
  const formmatedData = JSON.stringify(updatedObj, (key, value) => formatData(key, value));

  return JSON.parse(formmatedData);
};

export const getFormattedLocale = (locale) => locale.split('-').join('_').toUpperCase();

export const formatLanguage = (language) => {
  const splittedString = language.split('-');
  return `${splittedString[0]}-${splittedString[1].toUpperCase()}`;
};
